import { render } from "./ui-task-list.vue?vue&type=template&id=759c5988"
import script from "./ui-task-list.vue?vue&type=script&lang=js"
export * from "./ui-task-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__